import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	purposeOptionRadio: {
		borderRadius: "8px",
		background: colors.gray[50],
		boxShadow: "0px 2px 4px 0px rgba(33, 36, 41, 0.08)",
		padding: "16px",
		cursor: "pointer"
	},
	purposeOptionTitle: {
		color: colors.gray[700],
		fontSize: theme.spacing(2),
		fontWeight: 600
	},
	purposeOptionText: {
		color: colors.gray[900],
		fontSize: theme.spacing(1.75),
		fontWeight: 400
	},
	purposeDialogSaveButton: {
		padding: theme.spacing(1.25, 4),
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor()),
		fontSize: theme.spacing(1.75),
		height: theme.spacing(5)
	},
	badge: {
		right: 5,
		top: 40,
		border: `2px solid ${theme.palette.background.paper}`,
		padding: "4px",
		borderRadius: "4px",
		fontSize: "10px",
		background: colors.purple[200],
		color: colors.getPrimaryColor(),
		fontWeight: 600,
		fontsize: "10px"
	}
}))

export default useStyles
